export enum FontColor{
  primary = 'primary-font-color',
  secondary = 'secondary-font-color'
}

export const fontColorValues = Object.values(FontColor)
export type fontColorArray = typeof fontColorValues
export type TypeFontColor = fontColorArray[number]
